class ResultAbResultSet
{
    map = (response) => response.answers.map((answer) => answer.answer);

    fromResponse = (response) => {
        let result = {
            'OK': 0,
            'NOK': 0,
            'COUNT': 0,
        };

        this.map(response).map((item) => {
            item = JSON.parse(item);

            result[item.value]++;
            result['COUNT']++;

            return item;
        })

        result['OK'] = Math.round((result['OK'] / result['COUNT']) * 100);
        result['NOK'] = Math.round((result['NOK'] / result['COUNT']) * 100);

        return result;
    }
}

export default new ResultAbResultSet();
